import React from 'react';
import Layout from '../../components/Layout/Layout';
import SourcesList from '../../components/Sources/SourcesList';
import WithAlert from '@hoc/WithAlert';

const SourcesPage = ({ showAlert }) => (
  <Layout className="sources-page">
    <SourcesList withTitle showAlert={showAlert} />
  </Layout>
);

export default WithAlert(SourcesPage);
